import {
    ENABLE_ADDRESS_CHECK as addressCheckEnabled,
    ENABLE_DELIVERY_CENTER as deliveryCenterEnabled,
    ENABLE_TELEGRAM_BROADCASTS as telegramBroadcastsEnabled,
    isEnabledEnvValue
} from "./featureFlags"

const domain = process.env.REACT_APP_DOMAIN
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL
const cdnBaseUrl = process.env.REACT_APP_CDN_BASE_URL
const analyticsApiUrl = process.env.REACT_APP_ANALYTICS_API_URL
const analyticsApiToken = process.env.REACT_APP_ANALYTICS_API_TOKEN
const enablePaidCourierMetrics = process.env.REACT_APP_ENABLE_PAID_COURIER_METRICS
const enableSalesAnalytics = process.env.REACT_APP_ENABLE_SALES_ANALYTICS
const deliverySlaMinutes = process.env.REACT_APP_DELIVERY_SLA_MINUTES
const orderIdentifierMode = process.env.REACT_APP_ORDER_IDENTIFIER_MODE
const orderKanbanWarningMinutes = process.env.REACT_APP_ORDER_KANBAN_WARNING_MINUTES
const orderKanbanDangerMinutes = process.env.REACT_APP_ORDER_KANBAN_DANGER_MINUTES
const deliveryCenterLateMinutes = process.env.REACT_APP_DELIVERY_CENTER_LATE_MINUTES
const courierLocationWsBaseUrl = process.env.REACT_APP_COURIER_LOCATION_WS_BASE_URL
const courierLocationWsAuthMode = process.env.REACT_APP_COURIER_LOCATION_WS_AUTH_MODE
const enableBranchPaymentPayme = process.env.REACT_APP_ENABLE_BRANCH_PAYMENT_PAYME
const enableBranchPaymentClick = process.env.REACT_APP_ENABLE_BRANCH_PAYMENT_CLICK
const enableBranchPaymentMulticard = process.env.REACT_APP_ENABLE_BRANCH_PAYMENT_MULTICARD
const deliveryBotLink = process.env.REACT_APP_LINK_TO_DELIVERY_BOT

if (!domain && !adminApiUrl) {
    throw Error("Error REACT_APP_DOMAIN or REACT_APP_ADMIN_API_URL not found!")
}

const getPositiveNumberEnvValue = (value: string | undefined, fallback: number) => {
    if (!value) return fallback

    const parsedValue = Number(value)
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallback
}

const getOptionalPositiveNumberEnvValue = (value: string | undefined) => {
    if (!value) return null

    const parsedValue = Number(value)
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null
}

const getEnabledEnvValue = (value: string | undefined, defaultValue: boolean) => {
    if (value === undefined || value === "") return defaultValue
    return isEnabledEnvValue(value)
}

const getOptionalEnvValue = (value: string | undefined) => {
    const trimmedValue = value?.trim()
    if (!trimmedValue || /^#\{.+}#$/.test(trimmedValue)) return ""
    if (["undefined", "null", "false", "0", "none"].includes(trimmedValue.toLowerCase())) return ""
    return trimmedValue
}

const getOptionalUrlEnvValue = (value: string | undefined) => {
    const normalizedValue = getOptionalEnvValue(value)
    if (!normalizedValue || !/^https?:\/\//i.test(normalizedValue)) return ""

    return normalizedValue
}

const kanbanWarningMinutes = getOptionalPositiveNumberEnvValue(orderKanbanWarningMinutes)
const kanbanDangerMinutes = getOptionalPositiveNumberEnvValue(orderKanbanDangerMinutes)

export const DOMAIN = domain
export const DOMAIN_API = domain ? `${domain}/api` : adminApiUrl!
export const ADMIN_API_URL = adminApiUrl || DOMAIN_API
export const CDN_BASE_URL = cdnBaseUrl || ""
export const ANALYTICS_API_URL = analyticsApiUrl || ""
export const ANALYTICS_API_TOKEN = analyticsApiToken || ""
export const ENABLE_PAID_COURIER_METRICS = isEnabledEnvValue(enablePaidCourierMetrics)
export const ENABLE_SALES_ANALYTICS = isEnabledEnvValue(enableSalesAnalytics)
export const ENABLE_DELIVERY_CENTER = deliveryCenterEnabled
export const DELIVERY_SLA_MINUTES = getPositiveNumberEnvValue(deliverySlaMinutes, 40)
export type OrderIdentifierMode = "number" | "external_number"
export const ORDER_IDENTIFIER_MODE: OrderIdentifierMode =
    orderIdentifierMode === "external_number" ? "external_number" : "number"
export const ORDER_KANBAN_AGE_TONE_CONFIG =
    kanbanWarningMinutes && kanbanDangerMinutes && kanbanWarningMinutes < kanbanDangerMinutes
        ? {
            warningMinutes: kanbanWarningMinutes,
            dangerMinutes: kanbanDangerMinutes
        }
        : null
export const DELIVERY_CENTER_LATE_MINUTES = getPositiveNumberEnvValue(deliveryCenterLateMinutes, 40)
export type CourierLocationWsAuthMode = "none" | "token" | "access_token"
export const COURIER_LOCATION_WS_BASE_URL = courierLocationWsBaseUrl || ADMIN_API_URL
    .replace(/^http/i, "ws")
    .replace(/\/api\/?$/, "/ws")
export const COURIER_LOCATION_WS_AUTH_MODE: CourierLocationWsAuthMode =
    courierLocationWsAuthMode === "token" || courierLocationWsAuthMode === "access_token"
        ? courierLocationWsAuthMode
        : "none"
export const ENABLE_BRANCH_PAYMENT_PAYME = getEnabledEnvValue(enableBranchPaymentPayme, true)
export const ENABLE_BRANCH_PAYMENT_CLICK = getEnabledEnvValue(enableBranchPaymentClick, true)
export const ENABLE_BRANCH_PAYMENT_MULTICARD = getEnabledEnvValue(enableBranchPaymentMulticard, false)
export const DELIVERY_BOT_LINK = getOptionalUrlEnvValue(deliveryBotLink)
export const HAS_DELIVERY_BOT_LINK = Boolean(DELIVERY_BOT_LINK)
export const ENABLE_TELEGRAM_BROADCASTS = telegramBroadcastsEnabled
export const ENABLE_ADDRESS_CHECK = addressCheckEnabled
